export default __webpack_public_path__ + "static/media/section3-img3.7323f7d6.png";